import { Checkbox, Item, ItemDescription, ItemHeader } from '@ibsys/kit';
import { FC, ReactNode } from 'react';
import { TruncatedText } from '../TruncatedText';

type Props = {
  /** Название записи — подпись флажка */
  title: ReactNode;
  /** Отличительный признак записи: код, почта, внешний идентификатор */
  hint?: ReactNode;
  description?: ReactNode;
  /** Запись отмечена */
  isChecked: boolean;
  onToggle: (isChecked: boolean) => void;
};

/** Строка записи в окне выбора из списка */
export const SelectionDialogRow: FC<Props> = ({ title, hint, description, isChecked, onToggle }) => (
  <Item variant="outline" size="sm" className="min-w-0">
    <ItemHeader className="min-w-0 gap-3">
      <Checkbox
        className="min-w-0"
        classNames={{ label: 'min-w-0 wrap-anywhere' }}
        value={isChecked}
        onChange={(value) => onToggle(value === true)}
        label={title}
      />
      {hint && <TruncatedText className="max-w-1/2 text-sm text-muted-foreground">{hint}</TruncatedText>}
    </ItemHeader>
    {description && (
      <ItemDescription className="min-w-0 pl-6">
        <TruncatedText>{description}</TruncatedText>
      </ItemDescription>
    )}
  </Item>
);
